import { ComponentPropsWithoutRef } from 'react';
import { cn } from '@/shared/lib/cn';
import { Layout } from '@/shared/ui/layout';
import './center.scss';

type Props = ComponentPropsWithoutRef<typeof Layout>;
export const Center = ({ children, className, ...props }: Props) => {
    return (
        <Layout className={cn('center', className)} {...props}>
            {children}
        </Layout>
    );
};
